import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded?: boolean;
  version?: string;
  push?: MetaPixel;
};
type MetaWindow = Window & {
  fbq?: MetaPixel;
  _fbq?: MetaPixel;
};
const META_PIXEL_ID = '1367632915547845';
export function App() {
  useEffect(() => {
    const w = window as MetaWindow;
    try {
      if (!w.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as MetaPixel;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        w.fbq = pixel;
        w._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen bg-ballet-canvas text-ballet-ink" data-id="element-0" data-mp="su445ggvx0ep">
      <noscript data-id="element-1" data-mp="swgmhuqk1csa">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1367632915547845&ev=PageView&noscript=1" alt="" data-id="element-2" data-mp="3684vetzoctf" />
      </noscript>
      <main data-id="element-3" data-mp="d3crffrqyaar">
        <Hero data-id="element-4" data-mp="d3wbp34vdary" />
        <TestimonialsStrip data-id="element-5" data-mp="d2biphy7dzw7" />
        <PainPoints data-id="element-6" data-mp="851kpdwr0fwr" />
        <SolutionReveal data-id="element-7" data-mp="86mgt7ypo6wq" />
        <TomosSection data-id="element-8" data-mp="86cnbaegjhma" />
        <BonusSection data-id="element-9" data-mp="83qj9kqrzk8t" />
        <PricingSection data-id="element-10" data-mp="3gkv0trn63pda" />
        <ExtendedTestimonials data-id="element-11" data-mp="3gmft1am0ew7z" />
        <Guarantee data-id="element-12" data-mp="3gja5w0wxy4ew" />
        <FAQ data-id="element-13" data-mp="3bmbevr8kqdkx" />
        <FinalCTA data-id="element-14" data-mp="3bmjnv81ksyqu" />
      </main>
      <Footer data-id="element-15" data-mp="3bnmgbkejr98v" />
      <PurchaseNotifications data-id="element-16" data-mp="3bnus18yxo8ih" />
    </div>;
}